var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96492 2.43018L6.50576 3.39929C6.99385 4.27386 6.79791 5.42114 6.02919 6.18987C6.02918 6.18987 6.02919 6.18987 6.02918 6.18988C6.02907 6.18999 5.09684 7.12243 6.78736 8.81294C8.47721 10.5028 9.40961 9.57193 9.41042 9.57112C9.41045 9.57109 9.41044 9.5711 9.41046 9.57108C10.1792 8.80238 11.3265 8.60646 12.201 9.09454L13.1701 9.63538C14.4907 10.3724 14.6467 12.2244 13.4859 13.3852C12.7884 14.0827 11.9339 14.6254 10.9894 14.6612C9.39924 14.7215 6.69882 14.3191 3.99001 11.6103C1.2812 8.90147 0.878773 6.20106 0.939053 4.61095C0.974862 3.66637 1.5176 2.8119 2.2151 2.1144C3.37589 0.953609 5.2279 1.10957 5.96492 2.43018Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.e5d2e51b2a054163c63762e1ba70cd80.svg";
export { ForwardRef as ReactComponent };